const styles = theme => ({
  settingsContainer: {
    width: "calc(100% - 100px)",
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      margin: "0 auto",
      marginBottom: theme.spacing(3),
      width: "100%"
    }
  },
  avatarContainer: {
    position: "relative",
    width: 210,
    height: 210,
    borderRadius: "50%",
    overflow: "hidden",
    marginBottom: theme.spacing(3)
  },
  image: {
    width: "100%",
    height: "100%"
  },
  addImageContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "25%",
    background: "rgba(255, 255, 255, 0.5)"
  },
  iconColor: {
    color: "#fff",
    width: 34,
    height: 31
  },
  LogoCustomizedColorContainer: {
    marginBottom: theme.spacing(5)
  },
  organizationPictureContainer: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  },
  customizedColorContainer: {
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(3)
    }
  },
  mainText: {
    color: theme.palette.primary.default
  },
  customizeColorsTitle: {
    color: theme.palette.primary.default
  },
  ColorBox: {
    width: 62,
    height: 23,
    borderRadius: 4,
    opacity: 1,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  textColorContainer: {
    color: theme.palette.primary.default,
    width: 75
  },
  resetButton: {
    color: [theme.palette.primary.default, "!important"],
    marginLeft: theme.spacing(1)
  },
  mainColorBlockPickerContainer: {
    position: "relative"
  },
  mainColorContainer: {
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  blockPickerContainer: {
    position: "absolute",
    top: 55,
    left: 8,
    zIndex: 1,
    boxShadow: "1px 1px 6px 2px rgba(0, 0, 0, 0.3)",
    borderRadius: 6,
    [theme.breakpoints.down("sm")]: {
      top: 55
    }
  },
  organizatonNameContainer: {
    width: "40%",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  phoneEmailContainer: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      display: "inline"
    }
  },
  nameShortName: {
    width: "40%",
    marginRight: "10px",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  greenCounter: {
    color: "green",
    position: "absolute",
    right: 0,
    top: 5
  },
  redCounter: {
    color: "red",
    position: "absolute",
    right: 0,
    top: 5
  },
  phoneEmail: {
    width: "40%",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  addressInput: {
    width: "100%"
  },
  locationSuggestionContainer: {
    position: "absolute",
    width: "100%",
    background: "#fff",
    boxShadow: `4px 3px 3px rgba(0, 0, 0, .3)`,
    zIndex: 5
  },
  locationSuggestion: {
    padding: `${theme.spacing(1)}px`,
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    "&:last-of-type": {
      borderBottom: "none"
    }
  },
  locationSuggestionActive: {
    background: "#f1f1f1"
  },
  map: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  organizationLogoTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.default
  },
  addtionalFieldsChooseTitleContainer: {
    margin: `${theme.spacing(6)}px 0 ${theme.spacing(6)}px`,
    padding: theme.spacing(3),
    border: `1px solid rgba(0, 0, 0, .2)`
  },

  additionalFieldsContainer: {
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: theme.spacing(2)
    }
  },
  additionalFieldContainer: {
    color: "#00000061",
    borderBottom: "1px solid #00000061"
  },
  additionalFieldsText: {
    color: theme.palette.primary.default,
    "& + button": {
      padding: 0
    }
  },
  grayText: {
    color: "#00000061"
  },
  chooseTitleContainer: {
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  chooseTitleText: {
    color: theme.palette.primary.default
  },
  selectContainer: {
    marginTop: 19,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },

  exampleContainer: {
    marginTop: theme.spacing(3)
  },
  exmpleContainerTitle: {
    marginBottom: theme.spacing(2),
    color: "#00000061"
  },
  rightExampleContainer: {
    marginLeft: theme.spacing(3)
  },
  avatar: {
    margin: "auto",
    width: 50,
    height: 50
  },
  nameText: {
    fontWeight: 600,
    color: theme.palette.primary.default
  },
  buttonsContainer: {
    marginTop: theme.spacing(3)
  },
  popover: {
    position: "absolute",
    zIndex: "2"
  },
  cover: {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px"
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },
  cancelSection: {
    marginTop: theme.spacing(4)
  },
  cancelHeading: {
    color: theme.palette.primary.default
  },
  cancelCopy: {
    marginTop: theme.spacing(1),
    color: theme.palette.primary.default
  },

  infoIcon: {
    fontSize: "small",
    position: "absolute",
    left: 85,
    top: 15,
    color: theme.palette.primary.default
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/IntegrationTextFields/styles.js